export default "__VITE_ASSET__C9pVlQb2__"